/// <amd-module name="typeahead/features/ShowEssOnFocusPersonalizedSuggestions" />

import {EssDataProvider} from "typeahead/core/EssDataProvider";
import {Experiment} from "typeahead/core/Experiment";
import {IDataProvider} from "typeahead/core/IDataProvider";
import {IDataProviderResponse} from "typeahead/core/IDataProvider";
import {IExperimentalFeature} from "typeahead/core/IExperimentalFeature";
import {IFocusSuggester} from "typeahead/core/IFocusSuggester";
import {IListItem} from "typeahead/core/IListItem";
import {ISuggesterResponse} from "typeahead/core/ISuggester";
import * as ExecutionHelper from "typeahead/core/plugins/ExecutionHelper";
import {IStripingConfiguration} from "typeahead/core/StripingConfiguration";
import * as StripingConfiguration from "typeahead/core/StripingConfiguration";
import {SuggesterId} from "typeahead/core/SuggestionsAggregator";

const configuration: IStripingConfiguration[] = [
    {
        clients: ["Homepage", "AWSHomepage", "FlightsLandingPage", "CarsLandingPage", "HotelsLandingPage"],
        tabs: ["flight", "hotel", "car", "activity"],
    },
    {
        clients: ["Hotels.Search", "LXLandingPage"],
    },
    {
        clients: ["Flights.Search"],
        experiment: {
            id: 15363,
            name: "RecentHistoryFSRP",
            value: 1,
        },
    },
    {
        clients: ["Cars.Search"],
        experiment: {
            id: 15364,
            name: "RecentHistoryCSRP",
            value: 1,
        },
    },
    {
        clients: ["LX.Search"],
        experiment: {
            id: 15365,
            name: "RecentHistoryLXSRP",
            value: 1,
        },
    },
];

export class ShowEssOnFocusPersonalizedSuggestions implements IFocusSuggester, IExperimentalFeature {
    private dataProvider: IDataProvider = new EssDataProvider();

    public getId(): SuggesterId {
        return SuggesterId.EssOnFocusPersonalizedSuggester;
    }

    public suggest(options: any, context: IContext): JQueryPromise<ISuggesterResponse> {
        let deferred: JQueryDeferred<ISuggesterResponse> = $.Deferred();
        ExecutionHelper.shouldExecute(context, configuration)
            .done((shouldExecute) => {
                if (shouldExecute) {
                    this.fetchSuggestionsAndResolve(deferred, options, context);
                } else {
                    this.resolve(deferred, []);
                }
            })
            .fail(() => {
                this.resolve(deferred, []);
            });
        return deferred.promise();
    }

    public getExperiments(): Experiment[] {
        return StripingConfiguration.getExperiments(configuration);
    }

    public suggestOnFocus(options: any, context: IContext) {
        return this.suggest(options, context);
    }

    private resolve(deferred: JQueryDeferred<ISuggesterResponse>, suggestions: IListItem[]): void {
        deferred.resolve({
            id: this.getId(),
            results: suggestions,
        });
    }

    private fetchSuggestionsAndResolve(
            deferred: JQueryDeferred<ISuggesterResponse>,
            options: any,
            context: IContext): void {
        let suggestions: IListItem[] = [];
        this.dataProvider
            .fetchData($.extend(true, {}, options, {context}, {personalize: true}))
            .then((response: IDataProviderResponse) => {
                if (response && response.results) {
                    suggestions = suggestions.concat(response.results);
                }
            })
            .always(() => {
                this.resolve(deferred, suggestions);
            });
    }
}
